var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignmentTurnedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 8.025L7.825 4.5L7.125 3.8L4.3 6.625L2.875 5.2L2.175 5.9L4.3 8.025ZM1.5 10.5C1.225 10.5 0.989583 10.4021 0.79375 10.2063C0.597917 10.0104 0.5 9.775 0.5 9.5V2.5C0.5 2.225 0.597917 1.98958 0.79375 1.79375C0.989583 1.59792 1.225 1.5 1.5 1.5H3.6C3.70833 1.2 3.88958 0.958333 4.14375 0.775C4.39792 0.591667 4.68333 0.5 5 0.5C5.31667 0.5 5.60208 0.591667 5.85625 0.775C6.11042 0.958333 6.29167 1.2 6.4 1.5H8.5C8.775 1.5 9.01042 1.59792 9.20625 1.79375C9.40208 1.98958 9.5 2.225 9.5 2.5V9.5C9.5 9.775 9.40208 10.0104 9.20625 10.2063C9.01042 10.4021 8.775 10.5 8.5 10.5H1.5ZM1.5 9.5H8.5V2.5H1.5V9.5ZM5 2.125C5.10833 2.125 5.19792 2.08958 5.26875 2.01875C5.33958 1.94792 5.375 1.85833 5.375 1.75C5.375 1.64167 5.33958 1.55208 5.26875 1.48125C5.19792 1.41042 5.10833 1.375 5 1.375C4.89167 1.375 4.80208 1.41042 4.73125 1.48125C4.66042 1.55208 4.625 1.64167 4.625 1.75C4.625 1.85833 4.66042 1.94792 4.73125 2.01875C4.80208 2.08958 4.89167 2.125 5 2.125Z",
    fill: "#F58634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentTurnedIn);
export default __webpack_public_path__ + "static/media/assignment_turned_in.bf9bf718e4df4a585fee25fdac5d7f3a.svg";
export { ForwardRef as ReactComponent };